import Axios from 'axios';
import { getEnv } from 'common/utils';
import responseHandler from 'common/service/utils/responseHandler';
import errorHandler from 'common/service/utils/errorHandler';

const fosHost = getEnv().fosHost;

export const FosTokenAxiosInstance = Axios.create({
  baseURL: fosHost,
  timeout: 10 * 60 * 1000, // 10min
});

FosTokenAxiosInstance.interceptors.response.use(responseHandler, errorHandler);
